import styled, { css } from "styled-components"

import Pc from "~/components/atoms/Pc"
import Sp from "~/components/atoms/Sp"
import Label from "~/components/atoms/Tag"
import Typography from "~/components/atoms/Typography"
import { Color, IsMobile, IsPC, LineHeight, RadiusSize, SpacingSize, TextSize } from "~/consts/style-mixins"

interface Props {
  title: string
  bgSrc: string
  isClose?: boolean
  className?: string
}

interface StyledProps {
  bgSrc: string
}

const SeminarHead = ({ title, isClose, bgSrc, className }: Props) => {
  return (
    <div className={className}>
      <StyledCoverImageWrapper>
        <StyledCoverImage bgSrc={bgSrc} />
        {isClose && (
          <StyledLabel size="Medium" color={Color.Attention}>
            募集終了
          </StyledLabel>
        )}
      </StyledCoverImageWrapper>
      <div>
        <StyledCategory>セミナー・相談会</StyledCategory>
        <Pc>
          <StyledTitle type="SubHero">{title}</StyledTitle>
        </Pc>
        <Sp>
          <StyledTitle type="SubHero">{title}</StyledTitle>
        </Sp>
      </div>
    </div>
  )
}

const StyledCoverImageWrapper = styled.div`
  position: relative;
`

const StyledCoverImage = styled.div`
  width: 100%;
  margin-bottom: ${SpacingSize.M}px;
  padding-top: 50%;
  border-radius: ${RadiusSize.Medium}px;
  background-size: cover;
  background-position: center center;
  ${({ bgSrc }: StyledProps) => css`
    background-image: url("${bgSrc}");
  `}
`

const StyledLabel = styled(Label)`
  width: 80px;
  position: absolute;
  ${IsPC(css`
    bottom: 16px;
    left: 16px;
  `)}
  ${IsMobile(css`
    bottom: 8px;
    left: 8px;
  `)}
`

const StyledCategory = styled.span`
  font-size: ${TextSize.M}px;
  line-height: ${LineHeight.S}%;
  font-weight: bold;
  color: ${Color.Primary};
`

const StyledTitle = styled(Typography)`
  margin: ${SpacingSize["3XS"]}px 0 0;
`

export default SeminarHead
